import { render, staticRenderFns } from "./Stamp.vue?vue&type=template&id=1af44dad"
import script from "./Stamp.vue?vue&type=script&lang=js"
export * from "./Stamp.vue?vue&type=script&lang=js"
import style0 from "./Stamp.vue?vue&type=style&index=0&id=1af44dad&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports